import { useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setOfflinePressure } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";


function OfflinePressure(){

    const [showModal,setShowModal] = useState(false);
   

    const myData = useSelector(state => state.offlineApi);

    let current_pressure = myData.offline_Pressure[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.offline_Pressure)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="offline-pressure" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="offlinepressure" checked={checked} onChange={(e) => {dispatch(setOfflinePressure(e.target.checked))}} />
                    <label htmlFor="offlinepressure" >Offline &shy;Pressure</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current Pressure : {parseFloat(current_pressure).toFixed(2)} <br/> Pascal </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#91c8e482"} />}
        </>
    );
}

export default OfflinePressure;